<template>
  <div>
    <el-tag
      v-for="(tag, index) in dynamicTags"
      :key="tag + index"
      :size="tagSize"
      :type="tagType"
      :closable="true"
      :close-transition="false"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>

    <el-select
      :placeholder="inputPlaceholder"
      class="select-primary"
      v-model="inputValue"
      ref="saveTagInput"
      :size="inputSize"
      @change="handleInputConfirm"
    >
      <el-option
        v-for="option in selectOptions"
        class="select-primary"
        :value="option"
        :label="option"
        :key="option">
      </el-option>
    </el-select>

  </div>
</template>

<script>
import {Option, Select, Tag} from 'element-ui';

export default {
  name: 'tags-select-input',
  components: {
    [Tag.name]: Tag,
    [Option.name]: Option,
    [Select.name]: Select,

  },
  props: {
    value: {
      type: Array,
      default: () => [],
      description: 'List of tags'
    },
    options: {
      type: Array,
      required: true,
      description: 'List of options'
    },
    tagType: {
      type: String,
      default: 'primary',
      description: 'Tag type (primary|danger etc)'
    },
    inputPlaceholder: {
      type: String,
      default: 'Add new tag !! 123',
      description: 'Tag input placeholder.'
    },
    inputSize: {
      type: String,
      default: 'mini',
      description: 'Input size: medium / small / mini'
    },
    tagSize: {
      type: String,
      default: 'small',
      description: 'Tag size: medium / small / mini'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },
  computed: {
    selectOptions: function () {
      return this.options.filter(n => !this.dynamicTags.includes(n))
    },
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.$emit('change', this.dynamicTags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        this.$emit('change', this.dynamicTags);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    onInput(evt) {
      this.$emit('input', evt.target.value);
    }
  },
  created() {
    this.$watch(
      'value',
      newVal => {
        this.dynamicTags = [...newVal];
      },
      {immediate: true}
    );
  }
};
</script>
